import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const TennisBallIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M1 8C1 6.38938 1.54396 4.9058 2.45818 3.72297C3.70371 4.73129 4.5 6.27265 4.5 8C4.5 9.72735 3.70371 11.2687 2.45818 12.277C1.54396 11.0942 1 9.61062 1 8Z"
		></path>
		<path
			fill="currentColor"
			d="M6 8C6 5.84752 5.02847 3.92196 3.5 2.63789C4.71677 1.61568 6.28648 1 8 1C9.71352 1 11.2832 1.61568 12.5 2.63789C10.9715 3.92196 10 5.84752 10 8C10 10.1525 10.9715 12.078 12.5 13.3621C11.2832 14.3843 9.71352 15 8 15C6.28648 15 4.71677 14.3843 3.5 13.3621C5.02847 12.078 6 10.1525 6 8Z"
		></path>
		<path
			fill="currentColor"
			d="M13.5418 3.72297C14.456 4.90581 15 6.38938 15 8C15 9.61062 14.456 11.0942 13.5418 12.277C12.2963 11.2687 11.5 9.72735 11.5 8C11.5 6.27265 12.2963 4.73129 13.5418 3.72297Z"
		></path>
	</svg>
))
